import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { ListingShortageInquiresRoutes  } from '../../../routes';

export const ListingShortageInquiresLayout = () => <SwitchRoute routes={ListingShortageInquiresRoutes} />;
